import { ShieldHalf } from "lucide-react";
import { NAV_LINKS } from "@/data/content";

export default function Footer() {
  return (
    <footer className="relative bg-[#05050A] border-t border-white/10 pt-20 pb-10 overflow-hidden" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-12 pb-16">
          <div className="max-w-md">
            <div className="flex items-center gap-2.5">
              <ShieldHalf className="w-6 h-6 text-[#22D3EE] drop-glow" strokeWidth={1.75} />
              <span className="font-display font-700 text-lg text-white">
                Enda<span className="text-[#22D3EE]">sphere</span>
              </span>
            </div>
            <p className="mt-5 text-sm text-slate-500 leading-relaxed">
              Global network and infrastructure provider. Anything in the sphere is protected.
            </p>
          </div>
          <nav className="flex flex-wrap gap-x-8 gap-y-3">
            {NAV_LINKS.map((l) => (
              <a key={l.href} href={l.href} className="text-xs uppercase tracking-[0.2em] text-slate-400 hover:text-[#22D3EE] transition-colors">
                {l.label}
              </a>
            ))}
          </nav>
        </div>

        {/* Big wordmark */}
        <div className="border-t border-white/10 pt-10">
          <div className="font-display font-900 text-[16vw] leading-none tracking-tighter text-transparent [-webkit-text-stroke:1px_rgba(255,255,255,0.06)] select-none pointer-events-none">
            ENDASPHERE
          </div>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row justify-between gap-4 text-[11px] uppercase tracking-[0.15em] text-slate-600">
          <span>© {new Date().getFullYear()} Endasphere. All rights reserved.</span>
          <span>Built for the edge · 312 locations</span>
        </div>
      </div>
    </footer>
  );
}
